import { ThemeSpaceVariable } from "@caspeco/casper-ui-library";

export interface ISafeAreaModel {
	Top: number;
	Bottom: number;
	Left: number;
	Right: number;
}

export class SafeAreaModel {
	readonly top: number = 0;
	readonly bottom: number = 0;
	readonly left: number = 0;
	readonly right: number = 0;

	constructor(values?: ISafeAreaModel) {
		if (values) {
			this.top = values.Top ?? 0;
			this.bottom = values.Bottom ?? 0;
			this.left = values.Left ?? 0;
			this.right = values.Right ?? 0;
		}
	}

	readonly topAsPx = (extraSpace?: ThemeSpaceVariable) => {
		if (extraSpace) {
			return `calc(${this.top}px + ${extraSpace})`;
		}
		return `${this.top}px`;
	};

	readonly bottomAsPx = (extraSpace?: ThemeSpaceVariable) => {
		if (extraSpace) {
			return `calc(${this.bottom}px + ${extraSpace})`;
		}
		return `${this.bottom}px`;
	};
}
